/**
 * ![indigo 50](https://mui.com/static/colors-preview/indigo-50-24x24.png) ![indigo 100](https://mui.com/static/colors-preview/indigo-100-24x24.png) ![indigo 200](https://mui.com/static/colors-preview/indigo-200-24x24.png) ![indigo 300](https://mui.com/static/colors-preview/indigo-300-24x24.png) ![indigo 400](https://mui.com/static/colors-preview/indigo-400-24x24.png) ![indigo 500](https://mui.com/static/colors-preview/indigo-500-24x24.png) ![indigo 600](https://mui.com/static/colors-preview/indigo-600-24x24.png) ![indigo 700](https://mui.com/static/colors-preview/indigo-700-24x24.png) ![indigo 800](https://mui.com/static/colors-preview/indigo-800-24x24.png) ![indigo 900](https://mui.com/static/colors-preview/indigo-900-24x24.png) ![indigo A100](https://mui.com/static/colors-preview/indigo-A100-24x24.png) ![indigo A200](https://mui.com/static/colors-preview/indigo-A200-24x24.png) ![indigo A400](https://mui.com/static/colors-preview/indigo-A400-24x24.png) ![indigo A700](https://mui.com/static/colors-preview/indigo-A700-24x24.png)
 */
const indigo = {
  /**
   * Preview: ![indigo 50](https://mui.com/static/colors-preview/indigo-50-24x24.png)
   */
  50: '#e8eaf6',
  /**
   * Preview: ![indigo 100](https://mui.com/static/colors-preview/indigo-100-24x24.png)
   */
  100: '#c5cae9',
  /**
   * Preview: ![indigo 200](https://mui.com/static/colors-preview/indigo-200-24x24.png)
   */
  200: '#9fa8da',
  /**
   * Preview: ![indigo 300](https://mui.com/static/colors-preview/indigo-300-24x24.png)
   */
  300: '#7986cb',
  /**
   * Preview: ![indigo 400](https://mui.com/static/colors-preview/indigo-400-24x24.png)
   */
  400: '#5c6bc0',
  /**
   * Preview: ![indigo 500](https://mui.com/static/colors-preview/indigo-500-24x24.png)
   */
  500: '#3f51b5',
  /**
   * Preview: ![indigo 600](https://mui.com/static/colors-preview/indigo-600-24x24.png)
   */
  600: '#3949ab',
  /**
   * Preview: ![indigo 700](https://mui.com/static/colors-preview/indigo-700-24x24.png)
   */
  700: '#303f9f',
  /**
   * Preview: ![indigo 800](https://mui.com/static/colors-preview/indigo-800-24x24.png)
   */
  800: '#283593',
  /**
   * Preview: ![indigo 900](https://mui.com/static/colors-preview/indigo-900-24x24.png)
   */
  900: '#1a237e',
  /**
   * Preview: ![indigo A100](https://mui.com/static/colors-preview/indigo-A100-24x24.png)
   */
  A100: '#8c9eff',
  /**
   * Preview: ![indigo A200](https://mui.com/static/colors-preview/indigo-A200-24x24.png)
   */
  A200: '#536dfe',
  /**
   * Preview: ![indigo A400](https://mui.com/static/colors-preview/indigo-A400-24x24.png)
   */
  A400: '#3d5afe',
  /**
   * Preview: ![indigo A700](https://mui.com/static/colors-preview/indigo-A700-24x24.png)
   */
  A700: '#304ffe',
} as const;

export default indigo;
